import React from 'react';
import merge from 'lodash/merge';
import { SelectOption, DataSelectProps } from '@im/ui-lib/SelectOption';

export default function IMSelectOption({ ...props }: DataSelectProps) {
  const selectOptionProps = merge(
    {
      MenuProps: {
        PaperProps: {
          sx: {
            '& .MuiList-root': {
              padding: '8px 12px',
            },
            '& .MuiMenuItem-root': {
              fontSize: '14px',
              fontWeight: 400,
              lineHeight: '22px',
              padding: '8px',
            },
            borderRadius: '4px',
            boxShadow: '0px 2px 6px rgba(51, 51, 51, 0.15)',
          },
        },
      },
    },
    props
  );
  return <SelectOption {...selectOptionProps} />;
}
